import { render, staticRenderFns } from "./type_table.vue?vue&type=template&id=a76dfcb2&scoped=true"
import script from "./type_table.vue?vue&type=script&lang=ts"
export * from "./type_table.vue?vue&type=script&lang=ts"
import style0 from "./type_table.vue?vue&type=style&index=0&id=a76dfcb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76dfcb2",
  null
  
)

export default component.exports